module.exports = __webpack_public_path__ + "img/2.4f2a2fa7.png";